import React from 'react';

export default class Collapsible extends React.Component {
  constructor() {
    super();
    this.state = { isOpen: false };
  }

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <div>
        <a onClick={this.toggle} className="collapse-info-header">
          <i className={`fa fa-caret-${this.state.isOpen ? 'right' : 'down'}`} />
        </a>
        <a onClick={this.toggle}>
          {this.props.title}
        </a>
        {this.state.isOpen
          ? <div className="collapse-info" dangerouslySetInnerHTML={{ __html: this.props.content }} />
          : null
        }
      </div>
    );
  }
}